module.exports = __webpack_public_path__ + "static/media/view-profile.47795a0b.svg";